import axios from "axios";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { ArticleItemProps } from "./constants";
import CategorizedArticle from "./CategorizedArticle";
import { useFocusProductStore } from "@/stores/useFoucsProductStore";
import { getFocusProducts } from "@/lib/Definitions";
import SlideFocusProduct from "../Product/SlideFocusProduct";
import Cookies from "js-cookie";
import HorizontalProduct from "../Product/HorizontalProduct";
import ShopAtMOOIMOM from "../Common/ShopAtMOOIMOM";


const MamapediaCategory = () => {
  const router = useRouter();
  const viewport = Cookies.get('viewport');
  const [ query, setQuery ] = useState(true);
  const [ page, setPage ] = useState(1);
  const [popularArticles, setPopularArticles] = useState<Array<ArticleItemProps>>([]);
  const [latestArticles, setLatestArticles] = useState<Array<ArticleItemProps>>([]);
  const { focusProduct, updateFocusProduct, getFocusProduct } = useFocusProductStore();
  const [focusProductData, setFocusProductData] = useState(getFocusProduct());
  const [isLoadMore, setIsLoadMore] = useState(true);

  const fetchArticles = async (type: string, start: number, end: number) => {
    try {
      const response = await axios.get(
        "/api/mamapedia/category?data=" + type + "&slug=" + router.query.slug + "&start=" + start + "&end=" + end,
      )

      if (response.status === 200) {
        if (type === "popular") {
          setPopularArticles(response.data);
        } else {
          if (response.data.length < 10) {
            setIsLoadMore(false);
          }

          setLatestArticles((prevArticles) => [...prevArticles, ...response.data]);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (query) {
      setQuery(true);
      fetchArticles("popular", 0, 10);
      fetchArticles("latest", 0, 10);
    }
  }, [router.query, query])

  useEffect(() => {
    const handleRouteChange = () => {
      setQuery(true);
      setPage(1);
      setPopularArticles([]);
      setLatestArticles([]);
    }

    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    };
  }, [router.events]);

  const handleLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
    fetchArticles("latest", page * 10, (page + 1) * 10);
  }

  useEffect(() => {
    if (focusProductData.data.length === 0 || focusProductData.update_date === null || focusProductData.update_date < Date.now() - 3600000) {
      getFocusProducts()
        .then((response) => {
          const data = {
            update_date: Date.now(),
            data: response
          }
  
          updateFocusProduct(data);
          setFocusProductData(data);
        })
    }
  }, [focusProductData, updateFocusProduct])

  useEffect(() => {
    setFocusProductData(getFocusProduct());
  }, [focusProduct, getFocusProduct])

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-x-8 ${viewport === "desktop" ? "container" : ""} mb-6`}>
      <div className="col-span-1 md:col-span-2">
        {popularArticles.length > 0 && (
          <div className={`${viewport === "desktop" ? "" : "container"} font-poppins mt-5`}>
            <CategorizedArticle articles={popularArticles} tittle="Popular Article" link={null} limit={true} />
          </div>
        )}
        {focusProductData.data.length > 0 && (
          <div className="bg-topTextBg py-4 container my-6 md:hidden">
            <SlideFocusProduct title="Trending Produk" link="/" link_name="Shop at MOOIMOM" products={focusProductData.data} />
          </div>
        )}
        {latestArticles.length > 0 && (
          <div className={`${viewport === "desktop" ? "" : "container"} font-poppins mt-5 mb-10`}>
            <CategorizedArticle articles={latestArticles} tittle="Latest Article" link={null} limit={false} />
            {isLoadMore && (
              <button
                className="w-full rounded bg-mooimom text-white text-sm leading-5 font-bold text-center py-2 px-4 mt-6"
                onClick={handleLoadMore}
              >
                Load More
              </button>
            )}
          </div>
        )}
      </div>
      <div className="sticky hidden col-span-1 md:block top-20 h-fit border border-reviewBg border-solid rounded-lg p-4">
        <div className="w-2/3 p-2 mb-4 text-sm font-bold text-center text-white rounded-md bg-mooimom">SẢN PHẨM XU HƯỚNG</div>
        {focusProductData.data.length > 0 && (
          focusProductData.data.map((product, index) => (
            <div key={index} className="mb-3">
              <HorizontalProduct product={product} fullWidth={true} />
            </div>
          ))
        )}
      </div>
      <ShopAtMOOIMOM />
    </div>
  )
}

export default MamapediaCategory
